interface InitializersState {
    finished: number;
    total: number;
}

const DEFAULT_STATE: InitializersState = {
    finished: 0,
    total: 0,
};

const getObservableStateProxy = (stateObj: InitializersState, onFinishedCallback: () => void): InitializersState => {
    const changeHandler: ProxyHandler<InitializersState> = {
        set(target, prop, value) {
            target[prop as keyof InitializersState] = value;
            if (prop === 'finished' && target.finished === target.total && target.total > 0) {
                onFinishedCallback();
            }
            return true;
        },
    };
    return new Proxy(stateObj, changeHandler);
};

class InitializerService {
    private state: InitializersState;

    checkInitializers(onFinishedCallback: () => void) {
        this.state = getObservableStateProxy(DEFAULT_STATE, onFinishedCallback);
        const allInitializers: NodeListOf<HTMLElement> = document.querySelectorAll('[data-js-init]');

        if (allInitializers.length > 0) {
            this.state.total = allInitializers.length;
            allInitializers.forEach((initializer) => {
                this.runInitializer(initializer);
            });
        } else {
            onFinishedCallback();
        }
    }

    runInitializer(initializer: HTMLElement) {
        const initializerName = initializer.dataset.jsInit;
        switch (initializerName) {
            case 'skip-links':
                import('../components/skip-links').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'header':
                import('../components/header').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'mainnav':
                import('../components/mainnav').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'search':
                import('../components/search').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'swiper':
                import('../components/swiper-factory').then((module) => {
                    module.default.initSwiperOnElement(initializer);
                    this.state.finished++;
                });
                break;
            case 'anchor-smooth-scroll':
                import('../components/anchor-smooth-scroll').then((module) => {
                    module.default.init();
                    this.state.finished++;
                });
                break;
            case 'collapsible-content':
                import('../components/collapsible-content').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'accordion':
                import('../components/accordion').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'konversionsbehandlung-check':
                import('../components/konversionsbehandlung-check').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'modal':
                import('../components/modal').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'advice-modal':
                import('../components/advice-modal').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'sticker':
                import('../components/randomSticker').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'random-pictures':
                import('../components/randomPictures').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'methodenfinder':
                import('../components/methodenfinder').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'mediathek':
                import('../components/mediathek').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'media-modal':
                import('../components/media-modal').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'language-switch':
                import('../components/language-switch').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'sharing-box':
                import('../components/sharing-box').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'random-image':
                import('../components/random-image').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'feedback':
                import('../components/feedback').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'kondometer':
                import('../components/kondometer').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'beratungsstellen':
                import('../components/beratungsstellen').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'safersexcheck':
                import('../components/safersexcheck').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'onlineberatung-new-entry':
                import('../components/onlineberatung-new-entry').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'onlineberatung-conditional':
                import('../components/onlineberatung-conditional').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'onlineberatung-conditional-select':
                import('../components/onlineberatung-conditional-select').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'onlineberatung-delete-profile':
                import('../components/onlineberatung-delete-profile').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'onlineberatung-callback-toggle':
                import('../components/onlineberatung-callback-toggle').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'ls-glossary':
                import('../components/ls-glossary').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'site-variants':
                import('../components/site-variants').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'sti-stoerer':
                import('../components/sti-stoerer').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'sti-videos':
                import('../components/sti-videos').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'sti-slider-stage-player':
                import('../components/sti-slider-stage-player').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            case 'sti-puppe-modal':
                import('../components/sti-puppe-modal').then((module) => {
                    module.default.init(initializer);
                    this.state.finished++;
                });
                break;
            default:
                console.warn(`InitializerService: No initializer found for "${initializerName}" via DOM element:`, initializer);
                this.state.finished++;
                break;
        }
    }
}

export default new InitializerService();
